import { useFieldFocus } from 'context/FieldFocusContext'
import { TextField, InputAdornment } from '@mui/material'
import { useRef, useEffect } from 'react'

const MuiTextField = ({
  id,
  name,
  onFocus,
  onBlur,
  enableHelpText,
  helpText,

  type,
  ...props
}) => {
  const { handleFocus, handleBlur, registerHelpField } = useFieldFocus()
  const inputRef = useRef(null)
  const fieldId = id || name

  useEffect(() => {
    if (enableHelpText && fieldId) {
      registerHelpField(fieldId, helpText)
    }
  }, [enableHelpText, fieldId])

  const styles = {
    '& .MuiInputLabel-asterisk': {
      color: '#ea0606',
    },

    '& input:-webkit-autofill': {
      boxShadow: '0 0 0px 1000px white inset !important',
    },

    '&>label': {
      fontSize: '14px',
      color: '#75787B',
      top: '-2px',
    },
    '&>label.Mui-focused': {
      fontSize: '1rem',
      color: '#2370ED',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.Mui-focused.Mui-error': {
      color: '#ea0606',
    },
    '&>label.MuiFormLabel-filled, &>label.MuiInputLabel-shrink': {
      fontSize: '1rem',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.MuiFormLabel-filled.Mui-disabled': {
      top: 0,
      background:
        'linear-gradient(to bottom, #fff 0%, #fff 50%, #e9ecef 50%, #e9ecef 100%)',
    },
    '&>div.MuiInputBase-root': {
      padding: '0!important',
      borderRadius: '4px !important',
    },
    '&>div.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#e9ecef!important',
    },
    '&>div.MuiInputBase-root.Mui-focused': {
      boxShadow: '0 0 0 1.5px #2370ED',
    },
    '&>div>.MuiInputBase-input': {
      width: '100%!important',
      padding: '0.75rem 1.75rem 0.75rem 0.75rem!important',
      display: 'flex',
    },
    '&>div.MuiInputBase-root>svg': {
      display: 'block',
      height: '1.5em',
      width: '1.5em',
      top: 'calc(50% - 0.75em)',
    },
    '&.linkedDisabled>div.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#F5EBFE !important',
      border: '1px solid #8F62F8',
    },
    '&.linkedDisabled>label.MuiFormLabel-filled.Mui-disabled, &.linkedDisabled>label.MuiInputLabel-shrink.Mui-disabled':
      {
        background:
          'linear-gradient(to bottom, #fff 0%, #fff 50%, #F5EBFE 50%, #F5EBFE 100%)',
        color: '#8F62F8',
      },
    '&.linkedDisabled>div>.MuiInputBase-input': {
      color: '#8F62F8',
      WebkitTextFillColor: '#8F62F8',
    },
  }

  return (
    <TextField
      sx={styles}
      {...props}
      id={fieldId}
      name={fieldId}
      inputRef={inputRef}
      onFocus={(e) => {
        handleFocus(fieldId, e.target)
        onFocus?.(e)
      }}
      onBlur={(e) => {
        handleBlur()
        onBlur?.(e)
      }}
      onMouseEnter={(e) => handleFocus(fieldId, e.currentTarget)}
      onMouseLeave={(e) => {
        if (document.activeElement !== e.currentTarget) {
          handleBlur()
        }
      }}
    />
  )
}

export default MuiTextField
